/**
 * Language JSONs stored in https://s3.console.aws.amazon.com/s3/buckets/7gt-i18n-test-resource-bundle-localization?prefix=delivery/&region=us-east-1 with prefix "admin-portal-web."
 */

import axios from 'axios'

const retrieveLanguage = async ({ component, app, platform, language }) => {
    const res = await axios({
        method: 'GET',
        url: `${process.env.REACT_APP_LOCALIZATION_BASE_PATH}/${component}/${app}-${platform}.${language}`,
        headers: {
            'Content-Type': 'application/json',
        },
    })

    return res.data.data
}

export default retrieveLanguage
